import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { sendFormData } from '../utils/WhatsApp';

const scrollReveal = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.4 } },
};

const LoanSteps = () => {
    const steps = [
        {
            title: "Apply for a Loan in Just 10 Minutes – Fast & Easy Process",
            description: "Apply online in just 10 minutes! Our quick and easy loan application process ensures fast approvals with minimal hassle. Get started today."
        },
        {
            title: "Get a Response in 1 Hour – Quick Loan Approvals",
            description: "No waiting! Hear back from us within 1 hour. We prioritize fast loan processing so you can get the funds you need without delay."
        },
        {
            title: "Decision in 24 Hours – Hassle-Free Loan Processing",
            description: "Fast decisions within 24 hours! Our streamlined loan approval process ensures you get a quick response with no unnecessary paperwork."
        },
        {
            title: "Receive Your Funds Quickly – Fast Loan Funding",
            description: "Funds deposited fast! Once approved, your loan is funded quickly, helping you move forward without financial stress. Apply now!"
        }
    ];

    const [formData, setFormData] = useState({
        name: "",
        number: "",
        email: "",
        borrowAmount: "",
        monthlySalary: "",
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "number") {
            value = value.replace(/^\+?91/, ""); // Remove +91 or 91
            value = value.replace(/^0+/, ""); // Remove leading zeros
            value = value.replace(/\s/g, ""); // Remove spaces
            value = value.replace(/\D/g, ""); // Remove non-numeric characters
            value = value.slice(0, 10); // Keep only 10 digits
        }

        if (name === "email") {
            value = value.trim(); // Just basic trim; no force block
        }

        if (name === "borrowAmount" || name === "monthlySalary") {
            value = value.replace(/\D/g, ""); // Remove non-digits
            value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas in INR format
        }

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); 
        
        try {
            await sendFormData(formData, 'Loan Apply');
            toast.success("Loan application sent , Our team will contact you soon.", {
                position: "top-center",
                autoClose: 3000
            });
            setFormData({
                name: "",
                number: "",
                email: "",
                borrowAmount: "",
                monthlySalary: "",
            });
        } catch (error) {
            toast.error("Failed to send. Please try again.", {
                position: "top-center",
                autoClose: 3000
            });
            console.error('error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <motion.div
            className="loan-steps-main-smco"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
        >
            <motion.h2 className="sections-title-smco" variants={scrollReveal}>
                <span className="horizontal-line"></span>Seamless Loan Journey
            </motion.h2>
            <motion.p className="sections-description-smco" variants={scrollReveal}>
                Quick and easy process to get your loan approved fast
            </motion.p>

            <motion.div className="loan-container-smco" variants={staggerContainer}>
                <motion.div className="loan-step-left-container-smco" variants={staggerContainer}>
                    <motion.h2 className="loan-step-left-container-title-smco" variants={scrollReveal}>
                        We usually follow 4 steps to get a better business loan.
                    </motion.h2>
                    <motion.div className="loan-step-left-container-timeline-smco" variants={staggerContainer}>
                        {steps.map((step, index) => (
                            <motion.div
                                key={index}
                                className={`loan-step-left-container-step-smco ${index === steps.length - 1 ? 'loan-step-left-container-last-step-smco' : ''}`}
                                variants={scrollReveal}
                            >
                                <motion.div className="loan-step-left-container-number-smco" variants={scrollReveal}>
                                    {index + 1}
                                </motion.div>
                                <motion.h3 className="loan-step-left-container-title-smco" variants={scrollReveal}>
                                    {step.title}
                                </motion.h3>
                                <motion.p className="loan-step-left-container-description-smco" variants={scrollReveal}>
                                    {step.description}
                                </motion.p>
                            </motion.div>
                        ))}
                    </motion.div>
                </motion.div>

                <motion.div className="loan-step-right-container-smco" variants={scrollReveal}>
                    <motion.h2 className="loan-step-left-container-title-smco" variants={scrollReveal}>
                        How much did you want?
                    </motion.h2>
                    <motion.form onSubmit={handleSubmit} className="loan-step-form-smco" variants={staggerContainer}>
                        <motion.div className="loan-step-form-group-smco" variants={scrollReveal}>
                            <label htmlFor="name" className="loan-step-form-label-smco">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Enter your name"
                                value={formData.name}
                                onChange={handleChange}
                                className="loan-step-form-input-smco"
                                required
                            />
                        </motion.div>

                        <motion.div className="loan-step-form-group-smco" variants={scrollReveal}>
                            <label htmlFor="number" className="loan-step-form-label-smco">Phone Number</label>
                            <input
                                type="tel"
                                id="number"
                                name="number"
                                placeholder="Enter your phone number"
                                value={formData.number}
                                onChange={handleChange}
                                className="loan-step-form-input-smco"
                                required
                                pattern="[0-9]{10}"
                                title="Enter a valid 10-digit mobile number"
                            />
                        </motion.div>

                        <motion.div className="loan-step-form-group-smco" variants={scrollReveal}>
                            <label htmlFor="email" className="loan-step-form-label-smco">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Enter your email"
                                value={formData.email}
                                onChange={handleChange}
                                className="loan-step-form-input-smco"
                                required
                            />
                        </motion.div>

                        <motion.div className="loan-step-form-group-smco" variants={scrollReveal}>
                            <label htmlFor="borrowAmount" className="loan-step-form-label-smco">Borrow Amount</label>
                            <input
                                type="text"
                                id="borrowAmount"
                                name="borrowAmount"
                                placeholder="Enter borrow amount"
                                value={formData.borrowAmount}
                                onChange={handleChange}
                                className="loan-step-form-input-smco"
                                required
                            />
                        </motion.div>

                        <motion.div className="loan-step-form-group-smco" variants={scrollReveal}>
                            <label htmlFor="monthlySalary" className="loan-step-form-label-smco">Monthly Salary</label>
                            <input
                                type="text"
                                id="monthlySalary"
                                name="monthlySalary"
                                placeholder="Enter monthly salary"
                                value={formData.monthlySalary}
                                onChange={handleChange}
                                className="loan-step-form-input-smco"
                                required
                            />
                        </motion.div>

                        <motion.button type="submit" className="loan-step-form-submit-smco" variants={scrollReveal} disabled={loading}>
                            {loading ? <span className="spinner"></span> : "Submit"}
                        </motion.button>
                    </motion.form>
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default LoanSteps;

